import request from './request';
let BaseUrl = 'https://itsh.indata3.com/';

//基本配置
export function getConfig(data) {
    return request({
        url: BaseUrl + 'api.php?m=get.getConfig',
        method: 'post',
        data
    })
}
//邮箱注册
export function emailLogin(data){
    return request({
        url: BaseUrl+'api.php?m=login.verify_email',
        method:'post',
        data
    })
};
//邮箱注册提交密码
export function getEmailCode(data){
    return request({
        url: BaseUrl+'api.php?m=login.email_register',
        method:'post',
        data
    })
};
//首页目录
export function getMenu(data) {
    return request({
        url: BaseUrl + 'api.php?m=get.getMenu',
        method: 'post',
        data
    })
}
//手机号/邮箱登录
export function getLogin(data) {
    return request({
        url: BaseUrl + 'api.php?m=login',
        method: 'post',
        data
    })
}
//手机号/邮箱注册
export function getRegister(data) {
    return request({
        url: BaseUrl + 'api.php?m=login.register',
        method: 'post',
        data
    })
}
//邮箱验证码
export function geteCode(data) {
    return request({
        url: BaseUrl + 'api.php?m=login.send_ecode',
        method: 'post',
        data
    })
}
//邮箱验证码
export function getpCode(data) {
    return request({
        header: {
            "content-type": "multipart/form-data",
        },
        url: BaseUrl + 'api.php?m=login.send_pcode',
        method: 'post',
        name: 'imgFile',
        data
    })
}
//图片上传
export function upImg(data) {
    return request({
        url: BaseUrl + 'kindeditor/php/uploadApi.php?mode=3',
        method: 'post',
        data
    })
}
//展商认证
export function getAttestation(data) {
    return request({
        url: BaseUrl + 'api.php?m=user.company_attestation',
        method: 'post',
        data
    })
}
//获取H5
export function getH5(data) {
    return request({
        url: BaseUrl + 'api.php?m=h5.api',
        method: 'post',
        data
    })
}
//获取个人信息
export function getUser(data) {
    return request({
        url: BaseUrl + 'api.php?m=user.my',
        method: 'post',
        data
    })
}
//翻译
export function getTranslate(data) {
    return request({
        url: BaseUrl + 'api.php?m=get.translate',
        method: 'post',
        data
    })
}
//意见反馈
export function getFeedback(data) {
    return request({
        url: BaseUrl + 'api.php?m=user.feedback',
        method: 'post',
        data
    })
}
//获取轮播图接口
export function getBanner(data) {
    return request({
        url: BaseUrl + 'api.php?m=data.ad',
        method: 'post',
        data
    })
}
//收藏
export function getCollect(data) {
    return request({
        url: BaseUrl + 'api.php?m=showarea.collect',
        method: 'post',
        data
    })
}
//获取展商推荐
export function getCompanylist(data) {
    return request({
        url: BaseUrl + 'api.php?m=showarea.company_list',
        method: 'post',
        data
    })
}
//获取精品展示
export function getProductlist(data) {
    return request({
        url: BaseUrl + 'api.php?m=showarea.product_list',
        method: 'post',
        data
    })
}
//获取嘉宾寄语
export function getFamouslist(data) {
    return request({
        url: BaseUrl + 'api.php?m=get.famous_person',
        method: 'post',
        data
    })
}
//获取嘉宾寄语详情
export function getFamousDetail(data) {
    return request({
        url: BaseUrl + 'api.php?m=get.famous_person_detail',
        method: 'post',
        data
    })
}
//获取云展展区列表
export function getAreaList(data) {
    return request({
        url: BaseUrl + 'api.php?m=showarea.showarea_list',
        method: 'post',
        data
    })
}
//获取云展展商列表
export function getCompanyList(data) {
    return request({
        url: BaseUrl + 'api.php?m=showarea.company_list',
        method: 'post',
        data
    })
}
//获取云展展商列表
export function getNewCompanyList(data) {
    return request({
        url: BaseUrl + 'api.php?m=showarea.company_pc_list',
        method: 'post',
        data
    })
}
//获取云展展商详情 25.8.26 更换成web专用接口，防止信息泄露 dxm
export function getCompanyDetail(data) {
    return request({
        url: BaseUrl + 'api.php?m=showarea.company_detail_web',
        method: 'post',
        data
    })
}
//获取筛选分类列表接口
export function getAll(data) {
    return request({
        method: 'POST',
        header: {
            "Content-Type": "application/x-www-form-urlencoded"
        },
        url: BaseUrl + 'api.php?m=linkage.all',
        data
    })
}
//获取筛选分类-国家
export function getCountry(data) {
    return request({
        method: 'POST',
        header: {
            "Content-Type": "application/x-www-form-urlencoded"
        },
        url: BaseUrl + 'api.php?m=showarea.company_country',
        data
    })
}
//获取筛选分类-届次
export function getSession(data) {
    return request({
        method: 'POST',
        header: {
            "Content-Type": "application/x-www-form-urlencoded"
        },
        url: BaseUrl + 'api.php?m=get.session',
        data
    })
}
//获取云展产品列表
export function getProductList(data) {
    return request({
        url: BaseUrl + 'api.php?m=showarea.product_list',
        method: 'post',
        data
    })
}
export function getProducDetail(data) {
    return request({
        url: BaseUrl + 'api.php?m=showarea.product_detail',
        method: 'post',
        data
    })
}

//获取精彩活动
export function getActivitylist(data) {
    return request({
        url: BaseUrl + 'api.php?m=get.activity_class',
        method: 'post',
        data
    })
}
//获取活动时间
export function getActivitytime(data) {
    return request({
        header: {
            "AID": "201910241150202lrX1u2kZI1ikoXK",
            "APIVER": "v1.0",
            "Accept": "application/json",
            "Content-Type": "application/x-www-form-urlencoded"
        },
        url: BaseUrl + 'api.php?m=get.activity_time',
        method: 'post',
        data
    })
}
//获取活动分类菜单
export function getActivityclass(data) {
    return request({
        header: {
            "AID": "201910241150202lrX1u2kZI1ikoXK",
            "APIVER": "v1.0",
            "Accept": "application/json",
            "Content-Type": "application/x-www-form-urlencoded"
        },
        url: BaseUrl + 'api.php?m=linkage.get',
        method: 'post',
        data
    })
}
//获取活动列表
export function getActivityitem(data) {
    return request({
        url: BaseUrl + 'api.php?m=get.activity_list',
        method: 'post',
        data
    })
}
//获取活动详情
export function getActivityDetail(data) {
    return request({
        url: BaseUrl + 'api.php?m=get.activity_detail',
        method: 'post',
        data
    })
}
//获取新闻资讯
export function getNewslist(data) {
    return request({
        url: BaseUrl + 'api.php?m=information.getList',
        method: 'post',
        data
    })
}
//获取新闻详情
export function getInformationDetail(data) {
    return request({
        url: BaseUrl + 'api.php?m=information.detail',
        method: 'post',
        data
    })
}
//获取商机列表
export function getNeedList(data) {
    return request({
        url: BaseUrl + 'api.php?m=need.getNeedList',
        method: 'post',
        data
    })
}
//获取商机需求标签
export function getNeedLabel(data) {
    return request({
        url: BaseUrl + 'api.php?m=need.getNeedLabel',
        method: 'post',
        data
    })
}
//发布需求
export function getPublish(data) {
    return request({
        url: BaseUrl + 'api.php?m=need.publish_need',
        method: 'post',
        data
    })
}
//需求详情
export function getNeedDetail(data) {
    return request({
        url: BaseUrl + 'api.php?m=need.getNeedDetail',
        method: 'post',
        data
    })
}
//编辑个人信息
export function updMemberinfo(data) {
    return request({
        url: BaseUrl + 'api.php?m=user.upd_memberinfo',
        method: 'post',
        data
    })
}
//应答需求
export function needReply(data) {
    return request({
        url: BaseUrl + 'api.php?m=need.needReply',
        method: 'post',
        data
    })
}
//暂停发布
export function editState(data) {
    return request({
        url: BaseUrl + 'api.php?m=need.editState',
        method: 'post',
        data
    })
}
//删除需求
export function delNeed(data) {
    return request({
        url: BaseUrl + 'api.php?m=need.delNeed',
        method: 'post',
        data
    })
}
//应答列表
export function replyList(data) {
    return request({
        url: BaseUrl + 'api.php?m=need.replyList',
        method: 'post',
        data
    })
}
//应答列表
export function sendEmial(data) {
    return request({
        url: BaseUrl + 'api.php?m=user.demand_send_emial',
        method: 'post',
        data
    })
}







